import { mapState } from 'vuex'
import time from 'js-time.js'
import { isPC,remToPx,fmoney,drag } from '@/utils/methods.js'


console.log("document.body.clientWidth: ",document.body.clientWidth);
let isWidthScreen = document.body.clientWidth > 800;  // 是否是宽屏


export default {
    data() {
        return {
            idk: Math.round(Math.random() * 1000000),  // 避免多个组件使用时，id冲突
            returnData: {x: 0, y: " ", y2: " "},  // 返回的数据  x:0, y:" ", y2:" "    可能存在多余的无用参数，如：y2:" "
            btnWidth:150,   // 透明轴的宽度
            // isBtnShow: true,  // 滑动按钮是否显示
        }
    },
    props:{
        type:{  type:String, required:false, default:'line'  },   // 图案类型  pillar、gradientLine、onLine、twoLine、waveLine、brokenLine
        xAxisType:{  type:String, required:false, default:"normal"  },  // test、normal 调试时显示的x轴刻度类型
        newTime:{  type:Number, required:false, default:time().valueOf()  },    // 画图的参考时间，月份刻度中要使用，获取时间戳，确定月份天数
        scale:{  type:Number, required:false, default:1  },    // 高度缩放

        width:{  type:Number, required:false, default:300  },
        height:{  type:Number, required:false, default:300  },
        padding:{  type:Array, required:false, default:function(){  return ['30px','30px','30px','30px']  }  },   // 上、右、下、左

        componentColor:{  type:String, required:false, default:"white"  },  // white  rgba(49,245,81,0.3)
        canvasColor:{  type:String, required:false, default:"rgba(0,0,0,0)"  },   // rgba(0,0,0,0)  rgba(245,125,49,0.3)
        axiosColor:{  type:String, required:false, default:"rgba(252,0,0,1)"  },    // 轴颜色
        // dot1的颜色、dot1的选中颜色、dot2的颜色、dot2的选中颜色                           gradientLine   ['red','red','blue','blue']
        // dot1、dot2的颜色、dot1、dot2的选中颜色                                        oneLine        ['red','blue']
        // dot1、dot2的颜色、dot1、dot2的选中颜色、dot3、dot4的颜色、dot3、dot4的选中颜色     twoLine        ['gray','red','gray','blue']
        // 线的颜色、起点渐变颜色、终点渐变颜色                                             waveLine、brokenLine   ['black','red','blue']
        colorArr:{  type:Array, required:false, default:function(){  return ['red','red','blue','blue','gray3','green3']  }  },
        btnColor:{  type:String, required:false, default:"#fe8888"  },

        // pillar                 线段宽
        // gradientLine           中间连线宽
        // oneLine、twoLine       较小的线宽
        // waveLine、brokenLine   实线宽
        lineWidth:{  type:Number, required:false, default:isWidthScreen ? 8 : 4  },   // 画图时的线段宽
        axiosWidth:{  type:Number, required:false, default:isWidthScreen ? 2 : 1  },   // 轴线宽度

        fontSize:{  type:Number, required:false, default:isWidthScreen ? 24 : 12  },     // 刻度文字大小
        color:{  type:String, required:false, default:"#cccccc"  },     // #cccccc
        textSpace:{  type:Number, required:false, default:6  },     // 刻度文字到轴的间距

        xAxis:{  type:Number, required:false, default:7  },  // x轴标量  24,7,31,12
        yAxis:{  type:Array, required:false, default:function(){  return [0,50,100,150,200,250,300]  }  },  // y轴标量

		xAxisStrs:{  type:Array, required:false, default:function(){  return [  ]  }  },
        yAxisStrs:{  type:Array, required:false, default:function(){  return [  ]  }  },
        dots:{  type:Array, required:false, default:function(){  return [  ]  }  },  // 点集合   [  {  x:10, y:50, y2:100  }, {  x:60, y:50, y2:200  },  ]
        minAxisSpace:{  type:Number, required:false, default:30  },        // 最小轴间距：x轴最小移动间距、点显示的范围（显示范围内只有1条线）
    },
    computed: {
        ...mapState(['week']),
    },
    filters: {
        fmoney,
    },
    methods: {
        time,
        isPC,
        remToPx,
        // 拖拽(obj,parentObj=document.documentElement,direction="xy",isPc=true,callback)：被拖拽的对象，限制范围的父级，方向(x,y,xy)，是否是电脑端，回调函数       支持电脑端、移动端
        drag,

        // 画圆（对象，点坐标，点坐标，颜色）
        circle(context,dot1,radius=6,color="red"){
            let height = this.height;

            context.beginPath();
            context.arc(dot1["x"],height-dot1["y"],radius,0,360*Math.PI/180,true);
            context.fillStyle=color;
            context.fill();
            context.closePath();
        },
        // 画柱子（1个点）（对象，点坐标，点坐标，颜色）  只有一种颜色，没有渐变
        pillar(context,dot1,color="red",lineWidth=this.lineWidth){
            var  height = this.height;

            context.lineWidth=lineWidth;
            context.lineCap="round";
            context.strokeStyle=color;

            context.beginPath();
            context.moveTo(dot1["x"],height - 0);
            context.lineTo(dot1["x"],height - (dot1["y"] - lineWidth/2));  // 处理突出的半圆
            context.stroke();
            context.closePath();
        },
        // 画线段（对象，点坐标，点坐标，颜色、线宽）    2中不同的颜色时，为渐变
        line(context,dot1,dot2,colorArr=["red","blue"],lineWidth=this.lineWidth){
            let height = this.height;
            context.lineWidth= lineWidth;
            context.lineCap="round";
            context.strokeStyle=colorArr[0];

            context.beginPath();
            context.moveTo(dot1["x"],height - (dot1["y"] + lineWidth/2));  // 处理突出的半圆
            context.lineTo(dot2["x"],height - (dot2["y"] - lineWidth/2));
            // 设置渐变填充颜色
            if(  colorArr.length>=2 && colorArr[0]!==colorArr[1]  ){
                let grd=context.createLinearGradient(0,height-dot1["y"],0,height-dot2["y"]);
                grd.addColorStop(0,colorArr[0]);
                grd.addColorStop(1,colorArr[1]);
                context.strokeStyle=grd;
            }
            context.stroke();
            context.closePath();

        },
         // 画线段（对象，点坐标，点坐标，颜色、线宽）    2中不同的颜色时，为渐变
        rectangleTwoDot(context,dot1,dot2,colorArr=["red","blue"]){
            let height = this.height;
            context.lineCap="round";
            context.strokeStyle=colorArr[0];
            context.fillStyle=colorArr[0];
            context.beginPath();
            // console.log('x=',dot1["x"],',y=',(height-dot1["y"]),',x2=',dot2["x"],',y2=',(height - dot2["y"]),',colorArr=',colorArr,',colorArr[0]=',colorArr[0],',1context.fillStyle=',context.fillStyle)
            context.moveTo(dot1["x"],height - dot1["y"]);  // 处理突出的半圆
            context.lineTo(dot2["x"],height - dot1["y"]);
            context.lineTo(dot2["x"],height - dot2["y"]);
            context.lineTo(dot1["x"],height - dot2["y"]);
            // 设置渐变填充颜色
            if(colorArr.length>=2 && colorArr[0]!==colorArr[1]  ){
                let grd=context.createLinearGradient(0,height-dot1["y"],0,height-dot2["y"]);
                grd.addColorStop(0,colorArr[0]);
                grd.addColorStop(1,colorArr[1]);
                context.strokeStyle=grd;
            }
            // console.log('x=',dot1["x"],',y=',(height-dot1["y"]),',x2=',dot2["x"],',y2=',(height - dot2["y"]),',colorArr=',colorArr,',context.fillStyle=',context.fillStyle)
            context.fill();
            context.closePath();

        },
        // 余玄曲线 dot2必须在dot1的右侧，否则出错    连续划线
        curve(context,dot1,dot2){
            let width = dot2.x -dot1.x;     // 四分之一正玹曲线的宽度
            let height = Math.abs(dot2.y - dot1.y)/2;     // 正玹曲线上下浮动的绝对值         是否绝对值
            let y = 0;

            for( let i=dot1.x; i<dot2.x; i++ ){
                let deg1 = (Math.PI/2)*((i-dot1.x)/(0.5*width));
                let deg2 = (Math.PI/2)*((dot2.x-i)/(0.5*width));

                // 高 凸
                if(  dot2.y<=dot1.y  ){
                    if(  i<=(dot1.x+dot2.x)/2  ){
                        y = dot1.y - height*(1-Math.cos(deg1));
                    }
                    else{
                        y = (dot1.y + dot2.y)/2 - height*Math.cos(deg2);
                    }
                }
                // 低 凸
                else{
                    if(  i<=(dot1.x+dot2.x)/2  ){
                        y = dot1.y + height*(1-Math.cos(deg1));
                    }
                    else{
                        y = (dot1.y + dot2.y)/2 + height*Math.cos(deg2);
                    }
                }
                context.lineTo(i, y);
            }
        },
        // 画折线（填充 + 描边）  连续划线
        brokenLine3(context,colorArr=["black","red","blue"],lineWidth=this.lineWidth){
            let height = this.height;
            let dots = this.dots;
            // context.beginPath();
            // 画填充色----------------------------------------------------------------------------------------------------------------------------
            for(  let i in dots  ){
               // console.log('i=',i);
                let colorIndex=(dots[i]["y"]/100-1);
                if(colorIndex<0){
                    colorIndex=0;
                }
                this.rectangleTwoDot(context,{"x":dots[i]['x'],"y":dots[i]['y']-100},{"x":dots[i]['x1'],"y":dots[i]['y']},[this.colorArr[colorIndex],this.colorArr[colorIndex]]);
            }
            // context.closePath();
        },
        // 画折线（填充 + 描边）  连续划线
        brokenLine(context,colorArr=["black","red","blue"],lineWidth=this.lineWidth){
            let height = this.height;
            let dots = this.dots;

            context.lineWidth= lineWidth;
            context.lineCap="round";
            context.strokeStyle=colorArr[0];
            context.fillStyle=colorArr[1];

            let leng = dots.length-1;
            let maxY = 0;


            // 画填充色----------------------------------------------------------------------------------------------------------------------------
            context.beginPath();
                context.moveTo(dots[0]["x"],height-1);
                for(  let i in dots  ){
                    let item = dots[i];
                    context.lineTo(item["x"],height-item["y"]);
                    maxY=Math.max(maxY,item["y"]);
                }
                context.lineTo(dots[leng]["x"],height-1);

                // 设置渐变填充颜色-------------------------
                if(  colorArr[1]!==colorArr[2]  ){
                    let grd=context.createLinearGradient(0,height,0,height-maxY);
                    grd.addColorStop(0,colorArr[1]);
                    grd.addColorStop(1,colorArr[2]);
                    context.fillStyle=grd;
                }
                context.fill();
                // context.fillRect(0,0,100,300);
            context.closePath();


            // 画边框线------------------------------------------------------------------------------------------------------------------------------
            context.beginPath();
                for(  let i in dots  ){
                    let item = dots[i];
                    if( i===0 )  context.moveTo(item["x"],height-item["y"]);
                    else  context.lineTo(item["x"],height-item["y"]);
                }
                context.stroke();
            context.closePath();
        },
        // 画波浪线（填充 + 描边）  连续划线
        waveLine(context,colorArr=["black","red","blue"],lineWidth= this.lineWidth){
            let height = this.height;
            let dots = this.dots;
            let leng = dots.length-1;
            let maxY = dots[0]["y"];
            // console.log('waveLine  ',dots,dots2)

            // y轴反向
            let dots2 = dots.map(currentValue => {
                return {
                    x:currentValue.x,
                    y:height - currentValue.y,
                }
            });

            // console.log('waveLine  ',dots,dots2)

            context.lineWidth= lineWidth;
            context.lineCap="round";
            context.strokeStyle=colorArr[0];
            context.fillStyle=colorArr[1];


            // 画填充色-----------------------------------------------------------------------------------------------------------
            context.beginPath();
            context.moveTo(dots2[0]["x"],height-1);   // 起点 x轴上
            for(  let i=1;i<dots2.length;i++  ){
                this.curve(context,dots2[i-1],dots2[i]);
                maxY=Math.max(maxY,dots2[i]["y"]);
            }
            context.lineTo(dots2[leng]["x"],height-1);  //终点 x轴上

            // 设置渐变填充颜色-------------------
            if(  colorArr[1]!==colorArr[2]  ){
                let grd=context.createLinearGradient(0,height,0,height-maxY);
                grd.addColorStop(0,colorArr[1]);
                grd.addColorStop(1,colorArr[2]);
                context.fillStyle=grd;
            }
            context.fill();
            // context.fillRect(0,0,100,300);
            context.closePath();


            // 画边框线-------------------------------------------------------------------------------------------------------------
            context.beginPath();
            for(  let i=1;i<dots2.length;i++  ){
                this.curve(context,dots2[i-1],dots2[i]);
            }
            context.stroke();
            context.closePath();
        },



        resetCanvas(context){
            if(  this.dots.length > 0  ){
                // 整体画完
                this.canvasAll(context);
            }
        },

        // 点击移动
        clickFn(){
            console.log("执行0-----------");

            let docu = document.querySelector(`#comp${  this.idk  }`);
            let oCanvas = docu.querySelector("#canvas");
            let context = oCanvas.getContext("2d");

            console.log("isPc: ",this.isPC() ? "电脑" : "手机");
            console.log(event);

            let left = 0;
            if(  event.changedTouches && event.changedTouches[0].pageX  ){
                left = event.changedTouches[0].pageX;
            }
            else{
                left = event.pageX;
            }

            if(  left>this.remToPx(3) && left<this.remToPx(3) + this.width  ){
                docu.querySelector("#drag").style.left = (left - this.remToPx(3)) + "px";
                this.scrollSuccess(docu,context);
            }
        }
    },
    created(){
        if(  this.scale>1  && this.yAxis.length>0  ){
            // console.log("缩放------------",this.scale);
            for(  let i=0; i<this.dots.length; i++  ){
                this.dots[i]["y"] = this.dots[i]["y"] / this.scale;
            }
        }
    },
    mounted(){
        let docu = document.querySelector(`#comp${  this.idk  }`);
        let oCanvas = docu.querySelector("#canvas");
        // let oCanvas = document.querySelectorAll('.canvas9999')[0];
        let context = oCanvas.getContext("2d");

        this.resetCanvas(context);


        // 添加滚动事件：滑动滚动轴
        this.drag(docu.querySelector("#drag"),docu.querySelector("#parent"),"x",this.isPC(),()=>{

        },()=>{
            this.scrollSuccess(docu,context);
        },()=>{
            this.scrollSuccess(docu,context);
        });


        // 初始化，滚动到最后一个点
        if(  this.dots.length > 0  ){
            let left = this.dots[this.dots.length-1]["x"] + 2;
            docu.querySelector("#drag").style.left = (left - this.axiosWidth*0.5) + "px";

            this.scrollSuccess(docu,context);
        }


    },
}